<template>
	<div class="all">
		<van-form v-if="isShow">
			<!-- <van-sticky>
				<van-steps :active="active" @click-step="clickStep">
					<van-step>单位信息</van-step>
					<van-step>人才信息</van-step>
					<van-step>同住人信息</van-step>
					<van-step>服务要求</van-step>
				</van-steps>
			</van-sticky> -->
			<div>
				<!-- 单位信息 -->
				<van-field v-model="formData.company" name="所属单位" required label="所属单位" placeholder="所属单位"
					:rules="[{ required: true, message: '请填写所属单位' }]" disabled="" />
				<van-field v-model="formData.department" label="所属部门" required placeholder="所属部门"
					:rules="[{ required: true, message: '请填写所属部门' }]" />
				<van-field v-model="formData.position" label="职务" required placeholder="职务"
					:rules="[{ required: true, message: '请填写职务' }]" />
				<van-field v-model="formData.name" maxlength="5" label="人才姓名" required placeholder="人才姓名"
					:rules="[{ required: true, message: '请填写人才姓名' }]" />
				<van-cell is-link title="证件类型" @click="certificateTypeShow = true" v-model="formData.credentialsType"
					required="" />
				<van-action-sheet v-model="certificateTypeShow" :actions="certificateTypes"
					@select="certificateTypeSelect" cancel-text="取消" />
				<van-field v-model="formData.idCard" label="证件号" required="" placeholder="请填写证件号"
					:rules="[{ required: true, message: '请填写证件号' }]" />


				<!-- <van-field v-model="formData.birthday" label="出生日期" :placeholder="'请填写出生日期'" input-align="left" 
					required :rules="[{ required: true, message: '请填写出生日期' }]" /> -->

				<van-field v-model="formData.birthday" label="出生日期" :placeholder="'请选择'" input-align="left" readonly
					right-icon="arrow" @click="showBeginDate" required
					:rules="[{ required: true, message: '请填写出生日期' }]" />
				<van-popup v-model="showPickerDate" position="bottom">
					<van-datetime-picker v-model="currentDate" type="date" @cancel="onCancelDate"
						@confirm="onConfirmDate" :formatter="formatter" :min-date="minDate" :max-date="maxDate" />
				</van-popup>



				<van-field name="radio" label="性别" required :rules="[{ required: true, message: '请选择性别' }]">
					<template #input>
						<van-radio-group v-model="formData.contractPeriod" direction="horizontal">
							<van-radio name="男">男</van-radio>
							<van-radio name="女">女</van-radio>
						</van-radio-group>
					</template>
				</van-field>

				<van-field name="radio" label="婚姻状况" required :rules="[{ required: true, message: '请选择婚姻状况' }]">
					<template #input>
						<van-radio-group v-model="formData.marriage" direction="horizontal">
							<van-radio name="未婚">未婚</van-radio>
							<van-radio name="已婚">已婚</van-radio>
						</van-radio-group>
					</template>
				</van-field>

				<van-field v-model="formData.phone" type="tel" label="手机号码" placeholder="请输入联系电话"
					:rules="[{ required: true, message: '请填写联系电话' }, { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！' }]"
					required="" maxlength="11" />
				<van-cell is-link title="人才级别" @click="talentLevelShow = true" v-model="formData.talentLevel"
					required="" />
				<van-field v-model="formData.likes" type="textarea" label="喜好" placeholder="喜好" />
				<van-field v-model="formData.remark" type="textarea" label="备注" placeholder="备注" />

				<van-action-sheet v-model="talentLevelShow" :actions="talentLevels" @select="talentLevelSelect"
					cancel-text="取消" />

				<!-- <van-field name="switch" label="是否有同住人" required="">
					<template #input>
						<van-switch v-model="formData.cohabitFlag" size="20" />
					</template>
				</van-field> -->
				<div style="margin: 0 10px;">
					<van-button type="info" block class="nextStep" @click="onSubmit">提 交</van-button>
				</div>

				<!-- <div style="margin: 0 10px;">
					<van-button type="info" block @click="nextStepClick1" class="nextStep">下一步</van-button>
				</div> -->
			</div>

			<!-- 	<div v-show="active==1">
				
			</div> -->



			<!-- <div v-show="active==2">
				
				<p style="position: relative;padding: 20px 10px;">
					<van-button icon="plus" type="primary" size="mini" @click="addBdCohabitInformationClick" /><span style="position: relative;top:5px;left: 10px;">添加同住人信息</span>
				</p>

				<div v-for="(item,index) in formData.bdCohabitInformationList">
					<van-field v-model="item.cohabitName" label="同住人姓名" required placeholder="同住人姓名" :rules="[{ required: true, message: '请填写同住人姓名' }]" />
					<van-field v-model="item.idCard" label="身份证号" required placeholder="身份证号" :rules="[{ required: true, message: '请填写身份证号' }]" />
					<van-field v-model="item.relation" label="与入住人关系" placeholder="与入住人关系" />
					<p style="position: relative;padding: 20px 10px;">
						<van-button icon="minus" type="primary" size="mini" @click="deleteBdCohabitClick(index)" />
					</p>
				</div>
				<div style="margin: 0 10px;">
					<van-button type="info" block class="nextStep" @click="bdCohabitClick">下一步</van-button>
				</div>
			</div>
 -->
			<!-- <div v-show="active==3">
				<van-field name="checkboxGroup" label="标准服务">
					<template #input>
						<van-checkbox-group v-model="formData.standardServicesList">
							<van-checkbox name="1">四件套</van-checkbox>
							<van-checkbox name="2">热水壶</van-checkbox>
							<van-checkbox name="3">吹风机</van-checkbox>
							<van-checkbox name="4">衣架</van-checkbox>
						</van-checkbox-group>
					</template>
				</van-field>
				<van-field v-model="formData.checkInRequire" rows="4" autosize label="入住要求" type="textarea" maxlength="100"
				 placeholder="请输入入住要求" show-word-limit />

				<div style="margin: 0 10px;">
					<van-button type="info" block class="nextStep" @click="onSubmit">提 交</van-button>
				</div>
			</div> -->
		</van-form>
		<div v-else style="display: flex;justify-content: center;margin-top: 150px;">
			<div>
				<img src="../assets/icon/success.png" alt="" style="width: 12rem;height: 12rem;">
				<p style="text-align:center;color: #008000;">提交成功</p>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import {
	Toast
} from 'vant';

Vue.use(Toast);

export default {
	data() {
		return {
			isShow: true,
			minDate: new Date(1900, 0, 1),
			maxDate: new Date(),
			active: 0,
			formData: {
				costList: [], //费用列表
				applyFilePathList: [], //申报文件列表
				name: null, //人才名称
				phone: null, //人才电话
				sex: null, //性别
				idCard: null, //身份证号
				talentLevel: null, //人才级别
				credentialsPath: null, //证件文件路径
				applyFilePath: null, //申请材料路径
				company: null, //所属单位
				department: null, //所属部门
				position: null, //职位/职称
				contractPeriod: "", //性别
				credentialsType: null, //证件类型
				birthday: null,
				credentialsPathList: [], //证件文件路径
				showCredentialsPathList: [], //证件展示路径
				likes: null,
				remark: null,
				certificateFilePath: null, //企业法人证
				checkInTime: null, //入住日期
				checkInPeriod: "一年", //入住期限
				distributionMode: "授权分配", //分配方式（1.授权分配，2.指定分配）
				cohabitFlag: false, //是否有同住人（1.是，2.否）
				standardServicesList: ["1",], //标准服务
				checkInRequire: null, //入住要求
				chargePerson: null, //申请负责人
				roomId: "", //住房的id
				marriage: null, //婚姻状况
				bdCohabitInformationList: [], //同住人信息对象集合


			},
			certificateTypeShow: false,
			currentDate: new Date(),
			showPickerDate: false,
			certificateTypes: [{
				name: "身份证"
			}, {
				name: "护照"
			}, {
				name: "港澳台通行证"
			}, {
				name: "外国人永久居留身份证"
			}], //证件类型
			talentLevelShow: false,
			talentLevels: [{
				name: "本科",
				value: 1,
			},
			{
				name: "硕士",
				value: 2,
			},
			{
				name: "博士",
				value: 3,
			},
			{
				name: "专家",
				value: 4
			},
			{
				name: "海归",
				value: 5
			}
			], //人才级别
		}
	},
	mounted() {
		this.$http.post("/api/ownerManage/getOwnerName", {
			ownerId: this.$route.query.ownerId
		}).then(res => {
			console.log(res);
			this.formData.company = res.data.data;
		})
	},
	methods: {
		// 日期组件自定义格式
		formatter(type, value) {
			if (type === 'year') {
				this.value1 = value // 可以拿到当前点击的数值
				return `${value}年`
			} else if (type === 'month') {
				this.value2 = value
				return `${value}月`
			}
			this.value3 = value
			return `${value}日`
		},
		onCancelDate() {
			this.showPickerDate = false
		},
		onConfirmDate() {
			console.log('date111--', this.value1) // 数值来自日期组件自定义格式的方法回调
			console.log('date222--', this.value2)
			console.log('date333--', this.value3)
			this.formData.birthday = `${this.value1}-${this.value2}-${this.value3}` // 字符串拼接 结果入2020-07-03
			this.onCancelDate()
		},
		// 显示查询日期
		showBeginDate() {
			this.showPickerDate = true
		},
		phoneValidator(val) {
			return /^1[3|4|5|6|7|8][0-9]\d{8}$/.test(val)
		},

		// 证件类型
		certificateTypeSelect(item) {
			this.certificateTypeShow = false;
			this.formData.credentialsType = item.name;
		},
		// 人才级别
		talentLevelSelect(item) {
			console.log(item);
			this.talentLevelShow = false;
			this.formData.talentLevel = item.name;
		},
		// 添加同住人
		addBdCohabitInformationClick() {
			this.formData.bdCohabitInformationList.push({
				cohabitName: null, //同住人名字
				idCard: null, //身份证
				relation: null, //与入住人关系
				phone: null, //电话	
			})
		},
		// 删除同住人
		deleteBdCohabitClick(index) {
			this.formData.bdCohabitInformationList.splice(index, 1);
		},
		nextStepClick1() {
			console.log(this.formData);
			if (this.formData.company == null || this.formData.company == "" || this.formData.department == null ||
				this.formData
					.department == "" || this.formData.position == null || this.formData.position == "") {
				Toast("信息填写不完整");
				return;
			}
			this.active = 1;

		},
		nextStepClick2() {
			if (this.formData.name == null || this.formData.name == "" || this.formData.idCard == null || this.formData
				.idCard ==
				"" || this.formData.talentLevel == null || this.formData.talentLevel == "" || this.formData.phone ==
				null || this.formData
					.phone == "" || this.formData.credentialsType == null || this.formData.credentialsType == "") {
				Toast("信息填写不完整");
				return;
			}

			if (this.formData.cohabitFlag) {
				this.active = 2;
			} else {
				this.active = 3;
				console.log(888888888);
			}
		},
		// 同住人下一步
		bdCohabitClick() {
			this.active = 3;
		},
		// 点击步骤条
		clickStep(index) {
			this.active = index;
		},
		onSubmit() {

			console.log(this.formData);
			let newFormData;
			newFormData = JSON.parse(JSON.stringify(this.formData));
			let result = this.talentLevels.filter(item => {
				return item.name == this.formData.talentLevel;
			})
			newFormData.birthday=new Date(this.formData.birthday).getTime()
			newFormData.talentLevel = result[0].value;
			newFormData.cohabitFlag = newFormData.cohabitFlag ? '是' : '否';
			this.$http.post("/api/checkInApply/addCheckInApply", {
				...newFormData,
			}).then(res => {
				if (res.data.code == 0) {
					this.isShow = false;
				} else {
					Toast(res.data.message);
				}
			})
		},
	},
}
</script>

<style scoped="scoped">
.all {
	box-sizing: content-box;
	background-color: white;
	height: 100%;
	overflow: scroll;
}

.van-checkbox {
	margin-bottom: 8px;
}

.nextStep {
	margin-top: 40px;
}
</style>
